import {Heading as NBHeading, Factory} from "native-base";
import {WithBaseStyles} from "../hoc";
export const Heading = WithBaseStyles(NBHeading, {
    baseStyle: {
        fontWeight: "500",
        mb: 2,
    },
    variants: {
        caps: {
            textTransform: "uppercase"
        }
    }
});

export const H1 = WithBaseStyles(Heading, {
    baseStyle: {
        fontSize: "2xl",
        mb: "0",
    }
});


export const H2 = WithBaseStyles(Heading, {
    baseStyle: {
        fontSize: "xl",
        mb: "0"
    },
});


export const H3 = WithBaseStyles(Heading, {
    baseStyle: {
        fontSize: "lg",
        mb: "0"
    },
});
